// test287
(287 && 0);
